<template>
    <!--弹窗-->
    <el-dialog :visible.sync="selectLanguageDialogVisible" :title="$t('菜品录入使用语言')" width="50%" center
               :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <div class="language-container">
            <div class="language-button"
                 v-for="(item, index) in translations"
                 :key="index"
                 @click="mainLanguage = item.name"
                 :class="{ selected: mainLanguage === item.name }">
                {{ item.text }}
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
<!--        <el-button @click="cancel">{{$t('取消')}}</el-button>-->
        <el-button type="primary" @click="confirm">{{$t('确定')}}</el-button>
      </span>
    </el-dialog>
</template>

<script>
export default {
    name: "mainLangSelDialog",
    data() {
        return {
            selectLanguageDialogVisible: false,
            mainLanguage: "chinese",
            translations: [
                {name: 'chinese', text: '中文'},
                {name: 'english', text: 'English'},
                {name: 'italian', text: 'Italiano'},
                {name: 'german', text: 'Deutsch'},
                {name: 'spanish', text: 'Español'},
                {name: 'french', text: 'Français'},
                {name: 'croatia', text: 'Hrvatska'},
                {name: 'slovenia', text: 'Slovenščina'},
                {name: 'hungarian', text: 'Magyar'}
            ]
        }
    },
    methods: {
        cancel() {
            const self = this
            if (this.mainLanguage) {
                this.selectLanguageDialogVisible = false;
            } else {
                this.$message({
                    type: 'warning',
                    message:self.$t('请先选择一个选项') 
                });
            }
        },
        //首次必须选择主语言的弹窗确认取消以及关闭操作
        confirm() {
            if (this.mainLanguage) {
                // localStorage.setItem("mainLanguage", this.mainLanguage)
                // this.langList = this.$refs.newBasic.composeLangStatus(0);
                this.$emit('selectCallback', this.mainLanguage)
                this.selectLanguageDialogVisible = false;
            } else {
                this.$message({
                    type: 'warning',
                    message:self.$t('请先选择一个选项') 
                });
            }
        },

        handleClose(done) {
            if (this.mainLanguage) {
                done();
            } else {
                this.$message({
                    type: 'warning',
                    message:self.$t('请先选择一个选项') 
                });
            }
        },
    }
}
</script>

<style scoped lang="scss">

.language-container {
    display: flex;
    flex-wrap: wrap;
}

.language-button {
    width: 18%;
    box-sizing: border-box;
    padding: 10px;
    text-align: center;
    border: 1px solid #DCDFE6;
    margin: 5px;
}

.language-button:hover {
    cursor: pointer;
    background-color: #409EFF;
    border-color: #409EFF;
    color: #FFF;
}

.language-container .selected {
    background-color: #409EFF;
    border-color: #409EFF;
    color: #FFF;
}
</style>


// WEBPACK FOOTER //
// src/components/common/mainLangSelDialog.vue